import PropTypes from "prop-types";
import * as React from "react";
import { Button, Typography, UploadIcon } from "../../../themeV2";
import css from "./DropZone.module.css";

const ACCEPTED = "image/png, image/jpeg";

const DropZone = function DropZone({ onFiles }) {
  const inputRef = React.useRef(null);
  const [isOver, setOver] = React.useState(false);

  return (
    <div
      className={css.zone}
      data-over={isOver || undefined}
      onDragOver={(event) => {
        event.preventDefault();
        setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={(event) => {
        event.preventDefault();
        setOver(false);
        onFiles([...event.dataTransfer.files]);
      }}
    >
      <UploadIcon aria-hidden="true" />
      <Typography variant="body-md" as="p" className={css.text}>
        Drop images here. Each one becomes a product.
      </Typography>
      <input
        ref={inputRef}
        type="file"
        accept={ACCEPTED}
        multiple
        hidden
        onChange={(event) => {
          const chosen = [...event.target.files];
          inputRef.current.value = "";
          onFiles(chosen);
        }}
      />
      <Button
        variant="tonal"
        size="sm"
        onClick={() => inputRef.current?.click()}
      >
        Choose images
      </Button>
    </div>
  );
};

DropZone.propTypes = {
  onFiles: PropTypes.func.isRequired,
};

export default DropZone;
